import styled from 'styled-components';
import SearchContainer from './SearchContainer';
import SearchBackground from './SearchBackground';
import SearchForm from './SearchForm';
import SearchHeader from './SearchHeader';
import SearchTabs from './SearchTabs';
import Button from '../../common/components/button/Button';
import ButtonGroup from '../../common/components/button/ButtonGroup';
import { media } from '../../common/components/ui/utils';
import colors from '../../common/components/ui/colors';

const SearchWrapMin = styled.div`
  position: relative;
  ${(props) => props.fixed && (`
    position: fixed;
    top: 11.5rem;
    z-index: 1;
  `)}
  margin: 0 auto;
  ${media.tabletWide`
    margin: 2rem auto;
  `}
`;

const SearchWrap = styled.div`
  ${media.tabletNarrow`
    max-width: 670px;
    margin: 0 auto;
  `}
`;

export const TinyButtonGroupWrap = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  padding: 0 1rem;
`;

export const TinyButtonGroup = styled(ButtonGroup)`
  position: relative;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  max-width: 320px;
  ${media.tabletNarrow`
    max-width: calc(600px + 2rem); 
  `}
  ${media.tabletWide`
    max-width: calc(960px + 2rem);
  `}
  box-sizing: border-box;
`;

export const TinyButton = styled(Button)`
  font-size: 0.675rem;
  color: white;
  background: #4a4a4a;
  border: 0;
  border-radius: .5em;
  padding: 0.75em 1em;
  margin: 0;
  position: relative;
  
  &:last-child:before {
    content: '';
    width: 1px;
    position: absolute;
    top: 3px;
    bottom: 3px;
    left: -1px;
    background: #9B9B9B;    
  }

  svg {
    fill: #9B9B9B;
    width: 0.8125rem;
    height: 0.8125rem;
    vertical-align: sub;
    margin-left: 0.25em;
  }

  &.active {
    background: ${colors.ORANGE_HIGHLIGHT};

    svg {
      fill: white;
    }
  }
`;

export default {
  SearchWrapMin,
  SearchWrap,
  SearchContainer,
  SearchBackground,
  SearchForm,
  SearchHeader,
  SearchTabs,
}



// WEBPACK FOOTER //
// ./src/modules/search/ui/index.js